<app-layout>
  <div class="talk-to-us">
    <div class="talk-to-us__section">
      <div class="talk-to-us__header">
        <div class="talk-to-us__title">
          <p class="h1 text-white">Fale conosco</p>
        </div>
        <div class="talk-to-us__subtitle">
          <p>Entre em contato e tire suas dúvidas</p>
        </div>
      </div>
    </div>

    <div class="talk-to-us__text">
      <div class="container">
        <div class="contacts">
          <div class="whatsapp">
            <i class="ph ph-whatsapp-logo"></i>
            <div class="item">
              <h3>WhatsApp Comercial</h3>
              <span>+55 45 998029969</span>
            </div>
          </div>
          <div class="email">
            <i class="ph ph-envelope-simple-open"></i>
            <div class="item">
              <h3>E-mail para contato</h3>
              <span>contato&#64;yes7tickets.net</span>
            </div>
          </div>
          <div class="address">
            <i class="ph ph-map-pin"></i>
            <div class="item">
              <h3>Aonde estamos</h3>
              <span>Av. Brasil, 225 - Foz do Iguaçu PR</span>
            </div>
          </div>
          <div class="opening-hours">
            <i class="ph ph-clock"></i>
            <div class="item">
              <h3>Horário de atendimento</h3>
              <span>Segunda a sexta - 9h as 18h</span>
            </div>
          </div>
        </div>

        <form [formGroup]="contactUsForm" (ngSubmit)="onSubmit()">
          <div class="forms">
            <p class="form-description">Os campos marcados com (*) são de preenchimento obrigatório.</p>
            <div class="form-item">
              <label for="name">Nome *</label>
              <input class="name" formControlName="name" />
            </div>
            <div class="form-item">
              <label for="email">E-mail *</label>
              <input class="email" formControlName="email" />
            </div>
            <div class="form-item">
              <label for="phone">Telefone *</label>
              <input class="phone" formControlName="phone" />
            </div>
            <div class="form-item">
              <label for="subject">Assunto *</label>
              <input class="subject" formControlName="subject" />
            </div>
            <div class="form-item">
              <label for="message" type="textarea">Mensagem *</label>
              <input class="message" formControlName="message" />
            </div>
            <div class="form-button">
              <button class="button-submit" type="submit">ENVIAR</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</app-layout>
